import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import { Link } from "gatsby";
var Footer = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(Footer, _React$Component);
    function Footer() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Footer.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement("footer", {
            className: "footer"
        }, /*#__PURE__*/ React.createElement("ul", null, /*#__PURE__*/ React.createElement("address", null, /*#__PURE__*/ React.createElement("h2", null, "American Softgels, Inc."), "100 Station Street Loyalhanna, PA 15661", /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("a", {
            type: "tel",
            href: "tel:5612081030"
        }, "(561)208-1030")), /*#__PURE__*/ React.createElement("div", {
            className: "footer__links"
        }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            to: "/"
        }, "Home")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            to: "/why-softgels"
        }, "Why Softgels")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            to: "/products"
        }, "Products")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            to: "/contact-us"
        }, "Contact Us")))));
    };
    return Footer;
}(React.Component);
export { Footer as default };
